import styled, { css } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

interface ContainerProps {
    isVisible?: boolean
}

export const Container = styled.div<ContainerProps>`
    width: 100%;
    left: 0;
    top: 40px;
    //z-index: 3;
    cursor: pointer;
    position: absolute;
    overflow: auto;
    height: 0;
    transition: height 0.33ms ease;
    font-size: 0.9rem;
    border: 2px solid ${ThemeColors.accentGreenLight};
    color: ${ThemeColors.getGrayColor(0.7)};
    z-index: 3;
    box-sizing: border-box;
    outline: none;
    -webkit-appearance: none;
    background-color: ${ThemeColors.white};
    border-radius: 0.3rem;
    display: flex;
    flex-direction: column;


    ${(props) =>
        props.isVisible
            ? css`
                  height: 320px;
                  display: flex;
              `
            : css`
                  display: none;
              `}
}
`

export const SuggestWrapper = styled.div`
    flex-direction: column;
    color: ${ThemeColors.getGrayColor(0.7)};
    box-sizing: border-box;
    outline: none;
    -webkit-appearance: none;
    background-color: ${ThemeColors.white};
    width: 100%;
    height: 100%;

    & > div {
        box-sizing: border-box;
    }
`
export const ContainerEmpty = styled.div`
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
`
export const EmptyMessage = styled.span`
    color: ${ThemeColors.getGrayColor(0.4)};
`
export const RowContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
`

export const ButtonClose = styled.div`
    box-shadow: none;
    outline: none;
    margin: 0;
    border: none;
    cursor: pointer;
    width: 1.9rem;
    height: 100%;

    & svg {
        fill: ${ThemeColors.getGrayColor(0.4)};
    }

    &:hover > svg {
        fill: ${ThemeColors.black};
    }
`

export const HistoryContainer = styled.div`
    height: 100%;
`
export const HistoryRow = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    box-sizing: border-box;
    padding: 0.5rem 1.2rem;
`

export const DescriptionSpan = styled.div`
    /*    font-size: 17px;*/
    color: ${ThemeColors.getGrayColor(0.4)};
    font-weight: bold;
    padding: 0.5rem 0;
`
export const ButtonSpan = styled.span`
    font-weight: 400;
    color: ${ThemeColors.getGrayColor(0.5)};
`
